import React from 'react';
import { IonIcon } from '@ionic/react';
import { flagOutline } from 'ionicons/icons';
import { IPost } from '../interfaces/post.interface';
import ReportPostModal from './ReportPostModal';
import { useAuthStore } from '../store/zustand';
import { Link } from 'react-router-dom';

const PostReport = ({
  post,
  iconSize,
  classNames = 'button-icon ml-auto',
}: {
  post: IPost;
  iconSize: 'lg' | 'xl';
  classNames?: string;
}) => {
  const currentUser = useAuthStore((state) => state.user);

  return (
    <div>
      {currentUser ? (
        <>
          <button
            type="button"
            className={classNames}
            data-uk-toggle={`target: #report-post-${post.id}`}
          >
            <IonIcon icon={flagOutline} className={`text-${iconSize}`} />
          </button>

          <ReportPostModal post={post} targetId={`report-post-${post.id}`} />
        </>
      ) : (
        <Link to="/login" className={classNames}>
          <IonIcon icon={flagOutline} className={`text-${iconSize}`} />
        </Link>
      )}
    </div>
  );
};

export default PostReport;
